export interface DossierComments {
  userName: string;
  comment: string;
  timestamp: string;
  commentType: DossierCommentsType;
  isPinned: boolean;
}

export type DossierCommentsType = `${DossierCommentsEnum}`;

export enum DossierCommentsEnum {
  chat = 'chat',
  abandon = 'abandon',
  sinister = 'sinister',
  appointment = 'appointment',
  insurer = 'insurer',
  finishLater = 'finishLater',
}
